import { searchTabsEnum } from "../Tabs";
import "./SearchTab.scss";

interface ISearchTab {
  tabName: searchTabsEnum;
  isActive: boolean;
  onClick: (tab: searchTabsEnum) => void;
}

export const SearchTab = ({ tabName, isActive, onClick }: ISearchTab) => (
  <button className={`searchTab ${isActive ? "isActive" : ""}`} onClick={() => onClick(tabName)}>
    {tabName}
  </button>
);
